import { CocheType } from '../cocheType'

export const PERMUTAR_NEUMATICOS_SET = 'PERMUTAR_NEUMATICOS::SET'
export const PERMUTAR_NEUMATICOS_RESET = 'PERMUTAR_NEUMATICOS::RESET'

export function setPermutarNeumaticos(matricula: string, vehicle: CocheType) {
  return {
    type: PERMUTAR_NEUMATICOS_SET,
    payload: { matricula, vehicle },
  }
}

export function resetPermutarNeumaticos() {
  return {
    type: PERMUTAR_NEUMATICOS_RESET,
  }
}
